"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SceneSurfaceCustom = void 0;
var react_1 = __importDefault(require("react"));
var SceneSurfaceCustom = function (_a) {
    var scene = _a.data.scene, _b = _a.size, size = _b === void 0 ? scene : _b, renderObjectOverlay = _a.renderObjectOverlay, children = _a.children;
    var scale = size.width / scene.width;
    var overlays = [];
    if (renderObjectOverlay) {
        overlays = scene.objects.map(function (object) {
            var width = object.frame.width * scale;
            var height = object.frame.height * scale;
            var overlay = renderObjectOverlay({
                object: object,
                unitsPerPixel: 1 / scale,
            });
            return overlay ? (react_1.default.createElement("div", { key: object.id, style: {
                    position: 'absolute',
                    left: "".concat(object.frame.x * scale, "px"),
                    top: "".concat(object.frame.y * scale, "px"),
                    width: "".concat(width, "px"),
                    height: "".concat(height, "px"),
                } }, overlay)) : null;
        });
    }
    return (react_1.default.createElement("div", { style: {
            position: 'relative',
            width: "".concat(size.width, "px"),
            height: "".concat(size.height, "px"),
            userSelect: 'none',
        } },
        children,
        overlays));
};
exports.SceneSurfaceCustom = SceneSurfaceCustom;
